import { IconDefinition } from "@fortawesome/pro-solid-svg-icons";
import { Group } from "../../../group";
import { Icon } from "../../../icon";
import { Stack } from "../../../stack";
import { Text } from "../../../text";
import { Markdown } from "../../../markdown";

/**
 * Renders a system status update message with optional icon and timestamp.
 * @param {IconDefinition} props.icon - Optional icon displayed alongside the status update.
 * @param {string} props.updateText - The status update text content rendered as markdown.
 * @param {string} props.user - Optional user name associated with the status update.
 * @param {string} props.sendDateTime - The formatted timestamp of when the update was sent.
 * @returns {JSX.Element} The StatusUpdate component.
 */
const StatusUpdate = ({
    icon,
    updateText,
    user,
    sendDateTime,
}: {
    icon?: IconDefinition;
    updateText: string;
    user?: string;
    sendDateTime: string;
}) => {
    return (
        <Group py="lg" gap="sm">
            {icon && <Icon size="sm" color="gray" icon={icon} />}
            <Stack gap="xxs" align="center">
                <Text dimmed size="sm" data-testid="status-update-by-user">
                    <Markdown
                        markdownString={updateText}
                        textProps={{ dimmed: true, span: true, style: { wordBreak: "break-word" } }}
                        imageProps={{ maw: "90%", preview: true }}
                        listItemProps={{ style: { wordBreak: "break-word" } }}
                    />
                    {user}
                </Text>
                <Text dimmed size="xxs" data-testid="status-update-send-date-time">
                    {sendDateTime}
                </Text>
            </Stack>
        </Group>
    );
};
/**
 * Loading skeleton placeholder for the StatusUpdate component.
 * @returns {JSX.Element} The StatusUpdateSkeleton component.
 */
const StatusUpdateSkeleton = () => {
    return <Text.Skeleton size="sm" my="lg" width="70%" />;
};
StatusUpdate.Skeleton = StatusUpdateSkeleton;

export { StatusUpdate };
